module.exports = __webpack_public_path__ + "img/gift5.a3399f5e.png";